import { type Expense } from '@webapp/modules/expense/entities/Expense'
import { useQueryExpense } from '../../models/useQueryExpense'

interface UseExpensePresenterParams {
  uuid: string
}

interface UseExpensePresenterReturn {
  expense: Expense | undefined
  isLoading: boolean
  error: Error | null
}

export const useExpensePresenter = ({
  uuid,
}: UseExpensePresenterParams): UseExpensePresenterReturn => {
  const { expense, isLoading, error } = useQueryExpense(uuid)

  return { expense, isLoading, error }
}
